import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/font.css';
import vant from 'vant'
import 'vant/lib/index.css'
import './styles/index.css'
import { i18n } from './i18n/index' //国际化
import { Toast, NavBar, Loading, Overlay } from 'vant';
import VueClipboard from 'vue-clipboard2'
import slideVerify from "vue-monoplasty-slide-verify"; 
import MyJSBridge from '@/common/NativeClientMethod/index.js'
import fixedBottom from '@/directives/fixedBottom.js'
Vue.directive('fixed-bottom', fixedBottom)


// 引入刚刚封装的拼音工具包
import { groupAndSortByLetter, getFirstLetter } from '@/utils/pinyin-helper';

// 挂载到全局原型
Vue.prototype.$pinyinUtils = {
  groupAndSort: groupAndSortByLetter,
  getLetter: getFirstLetter
};
// import VConsole from 'vconsole'

// new VConsole()

Vue.prototype.$JSBridge = MyJSBridge;
// 挂载到 Vue 原型上，注意命名加上 $ 规范
Vue.prototype.$VUE_APP_ENV = process.env.VUE_APP_ENV

Vue.config.productionTip = false;
Vue.prototype.$imageApi = process.env.VUE_APP_IMG;
Vue.use(ElementUI);
Vue.use(vant);
Vue.use(VueClipboard)
Vue.use(Toast)
Vue.use(NavBar)
Vue.use(slideVerify);
Vue.use(Loading);
Vue.use(Overlay);
Vue.mixin({
  beforeDestroy() {
    // 识别当前销毁的是否是 Vant 的 NavBar 组件
    if (this.$options.name === 'van-nav-bar') {
      // 1. 将 $refs.navBar 替换为一个安全的伪造对象
      // 这样即便 100ms 后的 getBoundingClientRect() 触发，也只会返回 0，绝不报错
      this.$refs = {
        navBar: {
          getBoundingClientRect() {
            return { height: 0, top: 0, bottom: 0, left: 0, right: 0, width: 0 };
          }
        }
      };
    }
  }
});
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
